import { gql } from '@apollo/client';

export const GET_PAYMENT_METHOD_SUMMARY = gql`
  query getPaymentMethodSummary {
    getPaymentMethodSummary {
      type
      displayName
      last4
      brand
      expMonth
      expYear
      bankName
    }
  }
`;
